import { gql } from '@apollo/client';
import { searchQueryTypes, searchCombo, daysOfWeek } from './utils';

export const fieldChangeTriggerFragment = gql`
  ${searchCombo}
  fragment FieldChangedTriggerFragment on FieldChangedTrigger {
    field
    onNewUserCreation
    searchCombo {
      ...SearchComboFragment
    }
  }
`;

export const purchaseTriggerFragment = gql`
  ${searchCombo}
  fragment PurchaseTriggerFragment on PurchasedTrigger {
    searchCombo {
      ...SearchComboFragment
    }
  }
`;

export const receivedApiTriggerTriggerFragment = gql`
  ${searchCombo}
  fragment ReceivedApiTriggerTriggerFragment on ReceivedApiTriggerTrigger {
    searchCombo {
      ...SearchComboFragment
    }
  }
`;

export const scheduledRecurringListTriggerFragment = gql`
  ${searchCombo}
  ${daysOfWeek}
  fragment ScheduledRecurringListTriggerFragment on ScheduledRecurringListTrigger {
    emailListId
    suppressionListIds
    startDate
    endDate
    recurDays
    minuteOfDay
    timeZone
    maxStartTimeOffsetInMinutes
    skipDaysOfWeek {
      ...DaysFragment
    }
    searchCombo {
      ...SearchComboFragment
    }
  }
`;

export const subscribedToListTriggerFragment = gql`
  ${searchCombo}
  fragment SubscribedToListTriggerFragment on SubscribedToListTrigger {
    emailListId
    searchCombo {
      ...SearchComboFragment
    }
  }
`;

export const triggeredByWorkflowTriggerFragment = gql`
  ${searchCombo}
  fragment TriggeredByWorkflowTriggerFragment on TriggeredByWorkflowTrigger {
    searchCombo {
      ...SearchComboFragment
    }
  }
`;

export const triggeredCustomEventTriggerFragment = gql`
  ${searchQueryTypes}
  ${searchCombo}
  fragment TriggeredCustomEventTriggerFragment on TriggeredCustomEventTrigger {
    eventName
    eventSearchQuery {
      ...QueryTypesFragment
    }
    searchCombo {
      ...SearchComboFragment
    }
  }
`;

/* Disabled in preparation for graphql linting */
/* eslint-disable */
export const betaTriggerFragments = gql`
  ${fieldChangeTriggerFragment}
  ${receivedApiTriggerTriggerFragment}
  ${scheduledRecurringListTriggerFragment}
  ${subscribedToListTriggerFragment}
  ${triggeredCustomEventTriggerFragment}
`;
/* eslint-enable */
